export const AUTH_TOKEN = '__ihtsd'
export const AUTH_ID_USER = 'auth_id_user'
export const AUTH_USERNAME = 'auth_username'
export const AUTH_TIPE = 'auth_tipe'
export const AUTH_NAMA = 'auth_nama'

export const AUTH_PENGAWAS_TAGIHAN = 'auth_pengawas_tagihan'

export const AUTH_PENGAWAS_PEKERJAAN = 'auth_pengawas_pekerjaan'

export const AUTH_KODE_OK_TAGIHAN = 'auth_kode_ok_tagihan'

export const AUTH_KODE_OK_PEKERJAAN = 'auth_kode_ok_pekerjaan'

export const AUTH_KODE_OK_RHI = 'auth_kode_ok_rhi'